var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUndo = function SvgUndo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 19H7V17H14.1C15.15 17 16.0623 16.6667 16.837 16C17.6123 15.3333 18 14.5 18 13.5C18 12.5 17.6123 11.6667 16.837 11C16.0623 10.3333 15.15 10 14.1 10H7.8L10.4 12.6L9 14L4 9L9 4L10.4 5.4L7.8 8H14.1C15.7167 8 17.1043 8.525 18.263 9.575C19.421 10.625 20 11.9333 20 13.5C20 15.0667 19.421 16.375 18.263 17.425C17.1043 18.475 15.7167 19 14.1 19Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjEgMTlIN1YxN0gxNC4xQzE1LjE1IDE3IDE2LjA2MjMgMTYuNjY2NyAxNi44MzcgMTZDMTcuNjEyMyAxNS4zMzMzIDE4IDE0LjUgMTggMTMuNUMxOCAxMi41IDE3LjYxMjMgMTEuNjY2NyAxNi44MzcgMTFDMTYuMDYyMyAxMC4zMzMzIDE1LjE1IDEwIDE0LjEgMTBINy44TDEwLjQgMTIuNkw5IDE0TDQgOUw5IDRMMTAuNCA1LjRMNy44IDhIMTQuMUMxNS43MTY3IDggMTcuMTA0MyA4LjUyNSAxOC4yNjMgOS41NzVDMTkuNDIxIDEwLjYyNSAyMCAxMS45MzMzIDIwIDEzLjVDMjAgMTUuMDY2NyAxOS40MjEgMTYuMzc1IDE4LjI2MyAxNy40MjVDMTcuMTA0MyAxOC40NzUgMTUuNzE2NyAxOSAxNC4xIDE5WiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";